import { MessageType, useAi } from '@/context/ai'
import { AIElementNames, eventsTracker } from '@/lib/eventsTracker'
import { PartnerAssistantPrompt } from '@/shared/api-generated-types'
import { useRouter } from 'next/router'

export interface Props extends Omit<PartnerAssistantPrompt, '__typename'> {}

const AssistantPromptCard = (props: Props): JSX.Element => {
  const { dispatch } = useAi()
  const router = useRouter()

  return (
    <div className="border border-[#E5E8EB] rounded-2xl p-4 relative shadow-lg">
      <div className="flex items-start mb-3">
        <img src="/icons/dialog.svg" width={22} alt="dialog" height={20} loading="lazy" decoding="async" />
      </div>
      <h2 className="mt-3 mb-1 font-bold">{props.label}</h2>
      <p className="text-sm font-normal text-[#757582] mb-4">{props.description}</p>
      <div
        className="absolute bottom-2 right-5 underline text-orange-600 hover:text-orange-700 text-sm font-medium cursor-pointer"
        onClick={() => {
          eventsTracker.handleOnClickAndTrackEvent(AIElementNames.BUTTON_NIMDA_PROMPTS)
          dispatch({
            type: 'UPDATE',
            payload: { query: props.label, messageType: MessageType.UserStaticPrompt },
          })
          router.push('/helen')
        }}
      >
        Ask Helen
      </div>
    </div>
  )
}

export default AssistantPromptCard
